import { UPDATE_COMPANY_FEATURE_DATA } from 'constants/actions';

export const updateCompanyFeatureData = company_feature_data => {
  return { type: UPDATE_COMPANY_FEATURE_DATA, company_feature_data };
};
